import {
    CLEAR_DATA,
    CREATE,
    DELETE_DETAILS,
    EDIT_DETAILS,
    GET_LIST,
    UPDATE_DETAILS,
    VIEW_DETAILS
} from '../actions/listing_action';
import {CreateReducer} from '../utils/create_reducer';
import {COMPANY_API_URL, INSPECTION_API_URL, PROPERTY_API_URL,CUSTOMER_SERVICE_API_URL, PROPERTY_VISIT_API_URL} from '../constants/api_routes';

const initState = {
    isFetching: true,
    data: [],
    companyData: [],
    propertyData: [],
    inspectionData: [],
    customerServiceData: [],
    propertyVisitData: [],
    selectedObject: null,
    formActionStatus: '',
    statusMessage: ''
}

const listingReducer = CreateReducer(initState, {
    [GET_LIST](state, action) {
        switch (action.source) {
            case PROPERTY_API_URL :
                return {...state, propertyData: action.payload, isFetching: false};
            case COMPANY_API_URL :
                return {...state, companyData: action.payload, isFetching: false};
            case INSPECTION_API_URL :
                return { ...state, inspectionData: action.payload, isFetching: false };
            case CUSTOMER_SERVICE_API_URL :
                return { ...state, customerServiceData: action.payload, isFetching: false };
            case PROPERTY_VISIT_API_URL :
            return { ...state, propertyVisitData: action.payload, isFetching: false };
        default:
                return {...state, data: action.payload, isFetching: false};
        }
    },
    [VIEW_DETAILS](state, action) {
        return {...state, selectedObject: action.payload, isFetching: false};
    },
    [EDIT_DETAILS](state, action) {
        return {...state, selectedObject: action.payload, isFetching: false};
    },
    [CREATE](state, action) {
        return {...state, statusMessage: action.payload, isFetching: false};
    },
    [UPDATE_DETAILS](state, action) {
        return {...state, statusMessage: action.payload, isFetching: false};
    },
    [DELETE_DETAILS](state, action) {
        return {...state, statusMessage: action.payload, isFetching: false};
    },
    [CLEAR_DATA](state, action) {
        return {...initState,selectedObject:state.selectedObject};
    }
});

export default listingReducer;


// WEBPACK FOOTER //
// ./src/reducers/listing_reducer.js